// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-2OAUXAzg","foot_link":"foot_link-1B5TN_3e","list":"list-18dODzPT","link":"link-3a2pfNk9","copyright":"copyright-gOV49q4T"};